import React from "react";
import Loader from "../Loader/Loader";
import Pagination from "../Pagination/Pagination";

const MobileCardList = ({
    isMobile,
    loading,
    loaderText,
    data,
    renderItem,

    mobilePage,
    setMobilePage,

    totalPages,
    totalItems,
    pageSize
}) => {

    if (!isMobile) return null;

    return (
        <div className="space-y-4 mt-4 relative">

            {loading && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-white/70 backdrop-blur-sm">
                    <Loader message={loaderText} />
                </div>
            )}

            {data.map(item => (
                <div
                    key={item._id}
                    className="bg-white p-4 rounded-lg shadow border"
                >
                    {renderItem(item)}
                </div>
            ))}
            <Pagination
                page={mobilePage}
                totalPages={totalPages}
                totalItems={totalItems}
                pageSize={pageSize}
                onPageChange={setMobilePage}
            />


        </div>
    );
};

export default MobileCardList;
